import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment } from '@angular/router';

import { UpdateService } from '@core/services/update.service';

/**
 * Guard del comodín `**` (404). Cubre el caso en que un cliente quedó pegado a una versión vieja
 * cuyo router NO conoce una ruta que sí existe en una versión más nueva (deep link, ítem de menú
 * por permisos del backend, enlace de notificación…): en vez de mostrarle un 404 definitivo,
 * chequeamos si hay versión nueva y, de haberla, recargamos en la URL intentada para que el bundle
 * nuevo la resuelva.
 *
 * Es complementario de la red anti-`ChunkLoadError` (`handleChunkLoadError`): aquella cubre chunks
 * obsoletos; ésta cubre rutas que directamente no existen en el bundle viejo (no hay error de chunk).
 *
 * Siempre devuelve `true` (deja proceder el match → redirect a `/notfound`): la recuperación corre
 * en segundo plano y, si procede, su recarga full-load supera a la navegación SPA. Si no hay versión
 * nueva (404 real), se muestra el 404 normal sin recargas innecesarias.
 */
export const staleVersionGuard: CanMatchFn = (_route, segments: UrlSegment[]) => {
  const updateService = inject(UpdateService);
  const attemptedUrl = '/' + segments.map((s) => s.path).join('/');
  void updateService.recoverIfStale(attemptedUrl);
  return true;
};
